import { Controller } from '@hotwired/stimulus';

// Shared internship planning step (MGF-1772): the "individual / collective" radio
// drives the number of students. Individual => exactly 1 student, field hidden.
// Collective => field shown, 2 students minimum. The server enforces the same
// rules in MultiPlanning.
export default class extends Controller {
  static targets = ['individualRadio', 'collectiveRadio', 'maxCandidatesGroup', 'maxCandidatesInput'];

  connect() {
    this.toggle();
  }

  toggle() {
    if (this.individualRadioTarget.checked) {
      this.maxCandidatesInputTarget.value = 1;
      this.maxCandidatesInputTarget.min = 1;
      this.maxCandidatesGroupTarget.classList.add('fr-hidden');
      return;
    }

    this.maxCandidatesInputTarget.min = 2;
    if (parseInt(this.maxCandidatesInputTarget.value, 10) < 2 || this.maxCandidatesInputTarget.value === '') {
      this.maxCandidatesInputTarget.value = 2;
    }
    this.maxCandidatesGroupTarget.classList.remove('fr-hidden');
  }
}
